<template>
  <div class="d-flex align-center">
    <v-icon :color="iconColor" left class="material-icons-outlined">
      {{ icon }}
    </v-icon>
    {{ count }}
    <span
      class="d-inline-block text-truncate ml-1"
      style="max-width: 420px"
    >
      {{ statLabel }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'PrismaStatsCategory',
  props: {
    iconColor: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
    },
    statLabel: {
      type: String,
      default: null,
    },
    count: {
      type: Number,
      default: null,
    },
  },
};
</script>
